module.exports = __webpack_public_path__ + "img/case-user-ava2.22b5acda.png";